import { Colors } from '@doordash/design-language'
import styled from 'styled-components'
import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../constants'

export const PackagingImage = styled.div`
  width: 100%;
  background-color: ${Colors.SystemTeal10};
  height: 208px;
  background-size: cover;
  background-position: center;
  background-image: url(${`${CLOUDFLARE_DEFAULT_BASE},height=832/${AWS_BASE}/img/dasher/dd-welcome-bag.png`});
`
export const ActivationKitModalList = styled.div`
  display: flex;
`
export const HotBagImage = styled.div`
  border: 1px solid ${Colors.SystemGrey5};
  border-radius: 8px;
  width: 80px;
  height: 80px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-image: url(${`${CLOUDFLARE_DEFAULT_BASE},weight=160/${AWS_BASE}/img/dasher/dd-hotbag-hero.jpg`});
`
